import React from 'react';

const statusStyles = {
  active: { bg: 'rgba(16, 185, 129, 0.1)', color: '#10B981', dot: '#10B981' },
  expiring_soon: { bg: 'rgba(245, 158, 11, 0.1)', color: '#F59E0B', dot: '#F59E0B' },
  expired: { bg: 'rgba(239, 68, 68, 0.1)', color: '#EF4444', dot: '#EF4444' },
  terminated: { bg: 'rgba(107, 114, 128, 0.1)', color: '#6B7280', dot: '#6B7280' },
  archived: { bg: 'rgba(59, 130, 246, 0.1)', color: '#3B82F6', dot: '#3B82F6' },
  pending: { bg: 'rgba(59, 130, 246, 0.1)', color: '#3B82F6', dot: '#3B82F6' },
  confirmed: { bg: 'rgba(16, 185, 129, 0.1)', color: '#10B981', dot: '#10B981' },
  cancelled: { bg: 'rgba(239, 68, 68, 0.1)', color: '#EF4444', dot: '#EF4444' },
};

export default function StatusBadge({ status, className = '' }) {
  const style = statusStyles[status] || { bg: 'rgba(107, 114, 128, 0.1)', color: '#6B7280', dot: '#6B7280' };
  const label = (status || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-xl text-xs font-medium ${className}`}
      style={{ background: style.bg, color: style.color }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: style.dot }} />
      {label}
    </span>
  );
}
